{
    "PageTitle_auth": "Authentification",
    "NAME": "Router",
    "PageTitle_presence": "Présence",
    "PageTitle_changePassword": "Changer le mot de passe",
    "PageTitle_forgotPassword": "Mot de passe oublié",
    "PageTitle_changeLanguage": "Changer de langue",
    "PageTitle_resetPassword": "Réinitialiser le mot de passe",
    "PageTitle_termsAndConditions": "Termes et conditions",
    "PageTitle_cookiePolicy": "Politique relative aux cookies",
    "PageTitle_privacyPolicy": "politique de confidentialité",
    "PageTitle_mfa": "Authentification multifacteur",
    "PageTitle_teamsAuth": "Authentification des équipes",
    "PageTitle_insights": "Connaissances",
    "PageTitle_crmIntegration": "Intégration CRM",
    "PageTitle_changeUserAgent": "Changer l'agent utilisateur",
    "PageTitle_clientConfiguration": "Configuration du client",
    "PageTitle_CRMConfiguration": "Configuration CRM",
    "PageTitle_adminControl": "Contrôles d'administration"
}